<!-- ===== HEADER ===== -->
<div class="header-container">
  <!-- Row 1: Back, Title, PO Badge, Selected Info, Spacer, Buttons -->
  <div class="po-header__row-1">
    <button mat-icon-button class="po-header__back-btn" (click)="close()" matTooltip="Back">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <h4 class="header-title">{{isEditMode ? 'Edit Purchase Order' : 'Create Purchase Order'}}</h4>

    @if (isEditMode && purchaseOrderData?.po_number) {
      <span class="po-number-badge">
        <span class="po-number-badge__hash">#</span>{{purchaseOrderData?.po_number}}
      </span>
    }

    @if (materialList?.length) {
      <span class="po-header__selected-divider"></span>
    }
    @if (materialList?.length) {
      <span class="po-header__selected-info">
        {{getSelectedCount()}} items selected
        @if (getSelectedValue()) {
          <span>&middot; {{getSelectedValue() | currency:'USD'}}</span>
        }
      </span>
    }

    <span class="po-header__spacer"></span>

    @if (vendorGroupList?.length) {
      <button type="button" class="btn cancel-btn" (click)="close()">Cancel</button>
    }
    @if (vendorGroupList?.length) {
      <button type="button" class="btn add-purchase-order-button" (click)="save(purchaseForm)">
        <mat-icon class="po-save-icon">save</mat-icon>
        {{isEditMode ? 'Update Purchase Order' : 'Create Purchase Order'}}
      </button>
    }
  </div>

  <!-- Row 2: Job, Scope, Vendor, Vendor Quote, Toggles, Dates, Discount -->
  <div class="po-header__row-2">
    <!-- Group 1: Job/Scope/Vendor/VendorQuote -->
    <div class="po-header__group">
      <!-- Job Field - Hidden when creating from vendor quote -->
      @if (!isFromVendorQuote) {
        <div class="po-header__field po-header__field--job">
          <div class="inline-container">
            <!-- Regular Job -->
            @if (purchaseOrderObject.type==='regular') {
              <app-scrollable-search-field [disabled]="isEditMode" style="width: 100%;" id="customer_id"
                [dataService]="purchaseOrderService" [dataServiceFunctionName]="'search'"
                [searchPlaceHolder]="'Select Job'" [labelKey]="'name'"
                [formDataMapper]="{'id': 'id', 'name' : 'name'}" [keyNameToShowWhenSelected]="'name'"
                [additionalParams]="jobAdditionalParams"
                (selectedValueChange)="selectedValueChange($event,'job')" searchPlaceHolder="Job"
                [inputVal]="jobDetail" [ngClass]="{'disabled-field': isEditMode}">
              </app-scrollable-search-field>
            }
            <!-- Bulk Job -->
            @if (purchaseOrderObject.type==='bulk') {
              <app-scrollable-multiple-search-field [disabled]="isEditMode" style="width: 100%;" id="customer_id"
                [dataService]="purchaseOrderService" [dataServiceFunctionName]="'search'"
                [searchPlaceHolder]="'Select Job'" [labelKey]="'name'"
                [formDataMapper]="{'id': 'id', 'name' : 'name'}" [keyNameToShowWhenSelected]="'name'"
                [additionalParams]="jobAdditionalParams"
                (selectedValueMultipleChange)="selectedValueChange($event,'job')" searchPlaceHolder="Job"
                [inputVal]="jobDetail" [multiple]="true" [ngClass]="{'disabled-field': isEditMode}">
              </app-scrollable-multiple-search-field>
            }
          </div>
        </div>
      }

      <!-- Scope Field for Regular - Hidden when creating from vendor quote -->
      @if (purchaseOrderObject.type==='regular' && !isFromVendorQuote) {
        <div class="po-header__field po-header__field--scope"
          >
          <div class="inline-container" [ngClass]="{'edit-mode-scope': isEditMode}">
            <app-scrollable-multiple-search-field style="width: 100%;" id="scope_regular"
              [dataService]="purchaseOrderService" [dataServiceFunctionName]="'scopeSearch'"
              [searchPlaceHolder]="'Select Scope(s)'" [labelKey]="'scope_name'"
              [formDataMapper]="{'scope_name':'scope_name','job_scope_ids':'job_scope_ids'}"
              [keyNameToShowWhenSelected]="'scope_name'" [additionalParams]="scopeAdditionalParam"
              (selectedValueMultipleChange)="selectedValueChange($event,'scope')"
              (selectedValueClear)="selectedValueClear($event,'scope')"
              searchPlaceHolder="Scope"
              [inputVal]="scopeName"
              [multiple]="true"
              [showError]="false">
            </app-scrollable-multiple-search-field>
          </div>
        </div>
      }

      <!-- Scope Field for Bulk - Hidden when creating from vendor quote -->
      @if (purchaseOrderObject.type==='bulk' && !isFromVendorQuote) {
        <div class="po-header__field po-header__field--scope"
          >
          <div class="inline-container" [ngClass]="{'edit-mode-scope': isEditMode}">
            <app-scrollable-multiple-search-field style="width: 100%;" id="customer_id"
              [dataService]="purchaseOrderService" [dataServiceFunctionName]="'scopeSearch'"
              [searchPlaceHolder]="'Select Scope'" [labelKey]="'scope_name'"
              [formDataMapper]="{'scope_name':'scope_name','job_scope_ids':'job_scope_ids'}"
              [keyNameToShowWhenSelected]="'scope_name'" [additionalParams]="scopeAdditionalParam"
              (selectedValueMultipleChange)="selectedValueChange($event,'scope')" (selectedValueClear)="selectedValueClear($event,'scope')" searchPlaceHolder="Scope"
              [inputVal]="scopeName"
              [showError]="false">
            </app-scrollable-multiple-search-field>
          </div>
        </div>
      }

      <!-- Vendor field -->
      <div class="po-header__field po-header__field--vendor">
        <div class="inline-container">
          <!-- Multiple vendor selection for bulk -->
          @if (purchaseOrderObject.type==='bulk') {
            <app-scrollable-multiple-search-field style="width: 100%;" id="vendor_bulk"
              [dataService]="purchaseOrderService" [dataServiceFunctionName]="'vendorSearch'"
              [searchPlaceHolder]="'Select Vendor(s)'" [labelKey]="'vendor_name'"
              [formDataMapper]="{'vendor_id': 'vendor_id', 'vendor_name' : 'vendor_name'}"
              [keyNameToShowWhenSelected]="'vendor_name'" [additionalParams]="{jobids:jobId}"
              (selectedValueMultipleChange)="selectedValueChange($event,'vendor')"  (selectedValueClear)="selectedValueClear($event,'vendor')" searchPlaceHolder="Vendor"
              [inputVal]="vendorDetail" [multiple]="true"
              [showError]="false"
              [disabled]="isFromVendorQuote">
            </app-scrollable-multiple-search-field>
          }

          <!-- Vendor selection for regular PO and vendor-based PO -->
          @if (purchaseOrderObject.type==='regular' || purchaseOrderObject.type==='vendor') {
            <!-- CREATE MODE: When from vendor quote, show disabled field with pre-selected vendor -->
            @if (!isEditMode && isFromVendorQuote) {
              <div style="width: 100%;" class="vendor-quote-field">
                <mat-form-field appearance="outline" style="width: 100%;" class="vendor-readonly-field">
                  <mat-label>Vendor</mat-label>
                  <input matInput [value]="vendorName" disabled style="color: #000;">
                </mat-form-field>
              </div>
            }
            <!-- Normal vendor selection for job-based PO -->
            @if (!isEditMode && !isFromVendorQuote) {
              <app-scrollable-multiple-search-field style="width: 100%;" id="vendor_regular_create"
                [dataService]="purchaseOrderService" [dataServiceFunctionName]="'vendorSearch'"
                [searchPlaceHolder]="'Select Vendor(s)'" [labelKey]="'vendor_name'"
                [formDataMapper]="{'vendor_id': 'vendor_id', 'vendor_name' : 'vendor_name'}"
                [keyNameToShowWhenSelected]="'vendor_name'" [additionalParams]="{jobids:jobId}"
                (selectedValueMultipleChange)="selectedValueChange($event,'vendor')"  (selectedValueClear)="selectedValueClear($event,'vendor')" searchPlaceHolder="Vendor"
                [inputVal]="vendorDetail" [multiple]="true"
                [showError]="false">
              </app-scrollable-multiple-search-field>
            }
            <!-- EDIT MODE: Keep existing single vendor selection -->
            @if (isEditMode) {
              <app-scrollable-search-field style="width: 100%;" id="vendor_regular_edit"
                [dataService]="purchaseOrderService" [dataServiceFunctionName]="'vendorSearch'"
                [searchPlaceHolder]="'Select Vendor'" [labelKey]="'vendor_name'"
                [formDataMapper]="{'vendor_id': 'vendor_id', 'vendor_name' : 'vendor_name'}"
                [keyNameToShowWhenSelected]="'vendor_name'" [additionalParams]="{jobids:jobId}"
                (selectedValueChange)="selectedValueChange($event,'vendor')" searchPlaceHolder="Vendor"
                [inputVal]="vendorName"
                [showError]="false">
              </app-scrollable-search-field>
            }
          }
        </div>
      </div>

      <!-- Vendor Quote field -->
      @if (isFromVendorQuote) {
        <div class="po-header__field po-header__field--vendor-quote">
          <div class="inline-container">
            <app-scrollable-multiple-search-field style="width: 100%;" id="vendor_quote_select"
              [dataService]="purchaseOrderService" [dataServiceFunctionName]="'vendorQuoteSearch'"
              [searchPlaceHolder]="'Select Vendor Quote(s)'" [labelKey]="'quotation_reference'"
              [formDataMapper]="{'id': 'id', 'quotation_reference' : 'quotation_reference'}"
              [keyNameToShowWhenSelected]="'quotation_reference'"
              [additionalParams]="vendorQuoteAdditionalParam"
              (selectedValueMultipleChange)="selectedValueChange($event,'vendorQuote')"
              (selectedValueClear)="selectedValueClear($event,'vendorQuote')"
              searchPlaceHolder="Vendor Quote"
              [inputVal]="vendorQuoteList"
              [multiple]="true"
              [showError]="false">
            </app-scrollable-multiple-search-field>
          </div>
        </div>
      }
    </div>

    <!-- Group 2: Toggles + Dates (separated) -->
    @if (purchaseOrderObject.type !== 'vendor' && !isFromVendorQuote) {
      <div class="po-header__group po-header__group--separated">
        <!-- Price Engineering Toggle -->
        <div class="po-header__toggle">
          <mat-slide-toggle [checked]="false" [(ngModel)]="purchaseOrderObject.price_engineering_flag"
          class="toggle_switch toggle_switch_new" (ngModelChange)="priceEngineeringToggle()">Price Engineering</mat-slide-toggle>
        </div>
        <!-- Exclude Date Toggle -->
        <div class="po-header__toggle">
          <mat-slide-toggle [checked]="false" [ngModelOptions]="{standalone:true}"
            (ngModelChange)="onChangeExcludeDate($event)" [(ngModel)]="exclude_date_boolean"
          class="toggle_switch toggle_switch_new">Exclude Date</mat-slide-toggle>
        </div>
        <!-- Date Pickers -->
        <div class="po-header__dates">
          <div class="position-relative">
            <input matInput [matDatepicker]="picker1" [(ngModel)]="fromDate" (ngModelChange)="dateChange()"
              (click)="picker1.open()" class="form-control input-with-icon po-header__date-input" placeholder="From" />
            <mat-datepicker-toggle matIconSuffix [for]="picker1" class="icon-inside-input">
              <img src="assets/img/calendar.png" matDatepickerToggleIcon alt="Calendar" />
            </mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </div>
          <span class="po-header__date-separator">to</span>
          <div class="position-relative">
            <input matInput [matDatepicker]="picker2" (ngModelChange)="dateChange()" [(ngModel)]="toDate"
              (click)="picker2.open()" class="form-control input-with-icon po-header__date-input" placeholder="To" />
            <mat-datepicker-toggle matIconSuffix [for]="picker2" class="icon-inside-input">
              <img src="assets/img/calendar.png" matDatepickerToggleIcon alt="Calendar" />
            </mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </div>
        </div>
      </div>
    }

    <!-- Group 3: Vendor Discount (separated) -->
    <div class="po-header__group po-header__group--separated">
      <div class="po-header__discount">
        <span class="d-flex align-items-center cursor-pointer"
                [ngClass]="{
                    'po-header__discount--has-discount': (discountList?.length || 0) > 0,
                    'po-header__discount--confetti': showDiscountConfetti
                }"
          [matMenuTriggerFor]="menu">
          <mat-icon>sell</mat-icon>
          <span class="po-header__discount-label">Vendor Discount</span>
        </span>

        <!-- `class`, not `panelClass`. MatMenu declares this input as
             `panelClass: ["class", "panelClass"]` — it is aliased to `class`,
             so writing `panelClass="..."` only sets a dead attribute on
             <mat-menu>, which renders nothing. The overlay never received the
             class, which is why every rule written for this panel has been
             unreachable and it fell back to Material's defaults. -->
        <mat-menu #menu="matMenu" class="custom-menu-panel">
          <!-- Show discounts if available -->
          @for (item of discountList; track item; let d = $index) {
            <div class="discount-container"
              (click)="$event.stopImmediatePropagation()">
              <div class="d-flex justify-content-between pl-3">
                <div class="pb-2 pt-2 discount-left-side">
                  <div class="pb-2 text-info">{{item?.vendor_name}} has the discount available</div>
                  <div class="pt-1 discount-amount font-bold">{{item?.vendor_discount_threshold|currency:'USD'}}
                  </div>
                  <div class="discount-total_amount pt-2">Total Amount</div>
                </div>
                <div class="discount-right-side d-flex align-items-center">
                  <div>
                    <!-- The id must be unique per row. It was a literal
                         "checkbox-18" inside this loop, so every vendor's label
                         pointed at the first vendor's input — clicking any row
                         but the first toggled the wrong discount, and the custom
                         round control could not track state. -->
                    <div class="checkbox-wrapper-18">
                      <div class="round">
                        <input type="checkbox" [id]="'discount-checkbox-' + d"
                          [disabled]="materialList?.length>0?false:true"
                          (ngModelChange)="selectVendorDiscount($event, item)"
                          [(ngModel)]="item.isSelected" [ngModelOptions]="{standalone:true}" />
                        <label [attr.for]="'discount-checkbox-' + d"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- Show message when no discounts available -->
          @if (!discountList || discountList.length === 0) {
            <div class="no-discounts-container py-2">
              <div class="text-center py-2 px-2">
                <div class="no-discount-icon mb-2">
                  <img src="../../../../assets/img/general_icons/shoppingmode_grey.svg"
                    alt="No Discounts"
                    style="width: 32px; height: 32px; opacity: 0.5;">
                </div>
                <div class="no-discount-text">
                  <p class="mb-1" style="color: #666; font-size: 14px; font-weight: 500;">
                    No Vendor Discounts Available
                  </p>
                  <p class="mb-0" style="color: #999; font-size: 12px;">
                    No discounts are currently offered
                  </p>
                </div>
              </div>
            </div>
          }
        </mat-menu>
      </div>
    </div>
  </div>
</div>

<!-- ===== BODY: Three-Panel Layout ===== -->
<div class="po-body material-container">

  <!-- Left Panel — Collapsed Strip -->
  @if (showMaterialPanel && isMaterialContainerCollapsed) {
    <div class="po-left-panel po-left-panel--collapsed"
      (click)="isMaterialContainerCollapsed = false">
      <mat-icon class="po-left-panel__collapsed-icon">inventory_2</mat-icon>
      <span class="po-left-panel__collapsed-label">Materials</span>
      <mat-icon class="po-left-panel__collapsed-expand">chevron_right</mat-icon>
    </div>
  }

  <!-- Left Panel — Material Selector (Expanded) -->
  @if (showMaterialPanel && !isMaterialContainerCollapsed) {
    <div class="po-left-panel">
      <!-- Header -->
      <div class="po-left-panel__header"
        (click)="isMaterialContainerCollapsed = true">
        <div class="po-left-panel__title-row">
          <mat-icon class="po-left-panel__icon">inventory_2</mat-icon>
          <span class="po-left-panel__title">Materials</span>
          @if (getSelectedMaterialCount()) {
            <span class="po-left-panel__count-badge">
              {{getSelectedMaterialCount()}} selected
            </span>
          }
          <mat-icon class="po-left-panel__collapse-chevron">chevron_left</mat-icon>
        </div>
        <!-- Search -->
        <div class="po-left-panel__search">
          <mat-icon class="po-left-panel__search-icon">search</mat-icon>
          <input type="text" placeholder="Search materials..."
            [(ngModel)]="materialSearchQuery" [ngModelOptions]="{standalone:true}"
            class="po-left-panel__search-input">
          @if (materialSearchQuery) {
            <button class="po-left-panel__search-clear"
              (click)="materialSearchQuery = ''" type="button">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>
      <!-- Filter row -->
      <div class="po-left-panel__filters">
        <select class="po-left-panel__vendor-filter" [(ngModel)]="leftPanelVendorFilter" [ngModelOptions]="{standalone:true}">
          <option value="">All Vendors</option>
          @for (v of vendorList; track v) {
            <option [value]="v.vendor_id || v.id">{{v.vendor_name || v.name}}</option>
          }
        </select>
        <button class="po-left-panel__ready-toggle" type="button"
          [class.po-left-panel__ready-toggle--active]="showReadyOnly"
        (click)="showReadyOnly = !showReadyOnly">Ready Only</button>
      </div>
      <!-- Material list grouped by job -->
      <div class="po-left-panel__list">
        @for (entry of materialsByJob | keyvalue; track trackByJobKey($index, entry)) {
          <div class="po-left-panel__job-group">
            <!-- Job header -->
            <button class="po-left-panel__job-header" (click)="toggleJobExpand(entry.key)">
              <mat-icon class="po-left-panel__chevron" [class.po-left-panel__chevron--expanded]="isJobExpanded(entry.key)">chevron_right</mat-icon>
              <mat-icon class="po-left-panel__folder-icon">folder</mat-icon>
              <span class="po-left-panel__job-name">{{entry.key}}</span>
              <span class="po-left-panel__job-count">{{entry.value.length}}</span>
              @if (getSelectedCountInJob(entry.key)) {
                <span class="po-left-panel__job-selected-count">
                  {{getSelectedCountInJob(entry.key)}}
                </span>
              }
            </button>
            <!-- Materials under job -->
            @if (isJobExpanded(entry.key)) {
              <div class="po-left-panel__materials">
                @for (mat of entry.value; track mat; let i = $index) {
                  <div
                    class="po-left-panel__material-item"
                    [class.po-left-panel__material-item--selected]="mat.isSelected"
                    (click)="selectedMaterial(!mat.isSelected, mat, i)">
                    <mat-checkbox [checked]="mat.isSelected" class="po-left-panel__mat-check bidone-checkbox"
                      (click)="$event.stopPropagation()"
                    (change)="selectedMaterial($event.checked, mat, i)"></mat-checkbox>
                    <div class="po-left-panel__material-info">
                      <div class="po-left-panel__material-code">
                        {{mat?.product_code || mat?.material_code}}
                        <span class="po-left-panel__status-badge"
                                          [ngClass]="{'po-left-panel__status-badge--ready': mat?.status === 'ready-to-order' || mat?.is_ready_to_order,
                                                       'po-left-panel__status-badge--approved': mat?.status === 'approved' || mat?.is_approved}">
                          {{(mat?.status === 'ready-to-order' || mat?.is_ready_to_order) ? 'READY' : (mat?.is_approved ? 'APPROVED' : 'PENDING')}}
                        </span>
                      </div>
                      <div class="po-left-panel__material-name">{{mat?.product_name}}</div>
                      <div class="po-left-panel__material-meta">
                        <mat-icon class="po-left-panel__vendor-icon">business</mat-icon>
                        <span>{{mat?.vendor_name}}</span>
                        <span>&middot;</span>
                        <span>{{mat?.quantity}} avail</span>
                        <span>&middot;</span>
                        <span class="po-left-panel__material-cost">{{mat?.unit_price | currency:'USD'}}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- Empty state -->
        @if (!materialList?.length) {
          <div class="po-left-panel__empty">
            <mat-icon>inventory_2</mat-icon>
            <p>Select job & scope to load materials</p>
          </div>
        }
      </div>
      <!-- Footer summary -->
      @if (getSelectedMaterialCount()) {
        <div class="po-left-panel__footer">
          <span>{{getSelectedMaterialCount()}} materials</span>
          <span class="po-left-panel__footer-value">{{getSelectedMaterialValue() | currency:'USD'}}</span>
        </div>
      }
    </div>
  }

  <!-- Center Panel -->
  <div class="po-center-panel">
    <form novalidate #purchaseForm="ngForm">

      <div class="po-center-panel__table-section">
        <div class="table-responsive">
          <table class="table table-bordered table-purchase-order" style="width:100%">
            <thead>
              <tr>
                <th scope="col"
                  [ngStyle]="{'padding': purchaseOrderObject.price_engineering_flag? '10px 15px':'10px 10px 0px 10px'}">
                  <mat-checkbox [disabled]="purchaseOrderObject.group_material_flag" class="example-margin bidone-checkbox"
                    class="pr-3" [(ngModel)]="allMaterialSelected"
                    [indeterminate]="someSelected"
                    (ngModelChange)="allMaterialSelection($event)"
                  [ngModelOptions]="{standalone:true}"></mat-checkbox>
                </th>
                <th scope="col">JOB NO </th>
                <th scope="col">MATERIAL </th>
                <th scope="col">VENDOR(S)</th>
                <th scope="col">SCOPES</th>
                <th scope="col" class="po-table__th-center">QTY IN HAND</th>
                <th scope="col" class="po-table__th-center">ORDER QTY</th>
                <th scope="col" class="po-table__th-right">UNIT COST</th>
                <th scope="col" class="po-table__th-right">CONTRACT COST </th>
                <th scope="col">EST. VENDOR TAX</th>
                @if (purchaseOrderObject.price_engineering_flag) {
                  <!-- Labelled once here; PREVIOUS/NEW are the sub-header row below. -->
                  <th scope="col" class="bg-lightgray" colspan="2">
                    PRICE ENGINEERING
                  </th>
                }
                <th scope="col" class="po-table__actions-th"></th>
              </tr>
              @if (purchaseOrderObject.price_engineering_flag) {
                <tr class="po-table__pe-subheader">
                  <!-- Spans the 10 columns before PRICE ENGINEERING: checkbox, job no, material,
                       vendor(s), scopes, qty in hand, order qty, unit cost, contract cost,
                       est. vendor tax. Keep in sync with the header row above. -->
                  <th colspan="10"></th>
                  <th class="po-table__pe-header--previous">PREVIOUS</th>
                  <th class="po-table__pe-header--new">NEW</th>
                  <th></th>
                </tr>
              }
            </thead>
            <tbody>
              @for (item of materialList; track item; let i = $index) {
                <tr class="table-content" [class.row-selected]="item.isSelected">
                  <td [ngStyle]="{'background-color': item.color}" class="text-black">
                    <mat-checkbox [(ngModel)]="item.isSelected" class="example-margin bidone-checkbox"
                      (ngModelChange)="selectedMaterial($event,item,i)"
                      [disabled]="purchaseOrderObject.group_material_flag"
                      [name]="'is_selected_' + i" [id]="'is_selected_' + i"
                    [ngModelOptions]="{standalone: true}"></mat-checkbox>
                  </td>
                  <td class="text-black" [ngStyle]="{'background-color': item?.color}">
                    <span class="po-table__job-cell">{{item?.job_number}}</span></td>
                    <td class="text-black" [ngStyle]="{'background-color': item?.color}">
                      <div class="po-table__material-cell">
                        <span class="po-table__material-code">{{item?.product_name}}</span>
                      </div>
                    </td>
                    <td class="text-black" [ngStyle]="{'background-color': item?.color}">
                      <div [matMenuTriggerFor]="menu"
                        (menuOpened)="getVendorPricing(item.vendor_id, item.material_id || item.product_id || item.id, item)"
                        class="d-flex align-items-center vendor_dropdown po-table__vendor-trigger">
                        <span>{{item?.vendor_name}}</span>
                        <mat-icon class="po-table__vendor-chevron">
                          keyboard_arrow_down
                        </mat-icon>
                      </div>
                      <mat-menu #menu="matMenu">
                        @if (isVendorListLoading(item)) {
                          <button class="import_btn" mat-menu-item disabled>
                            <span class="float_left f-14">Loading vendors…</span>
                          </button>
                        } @else {
                          @for (v of getVendorsFor(item); track v) {
                            <button class="import_btn" mat-menu-item
                              (click)="selectedVendor(item,v)">
                              <span class="float_left f-14">
                                {{v?.name}}
                              </span>
                            </button>
                          }
                          @if (!getVendorsFor(item).length) {
                            <button class="import_btn" mat-menu-item disabled>
                              <span class="float_left f-14">No vendors found</span>
                            </button>
                          }
                        }
                      </mat-menu>
                    </td>
                    <td class="text-black" [ngStyle]="{'background-color': item?.color}">
                      <span class="po-table__scope-cell">{{item?.scope_name}}</span></td>
                      <td class="text-black po-table__qty-hand-cell" [ngStyle]="{'background-color': item?.color}">
                      {{item?.quantity_on_hand||'-'}} </td>
                      <td class="po-table__order-qty-cell" [ngStyle]="{'background-color': item.color}">
                        <div class="d-flex align-items-center gap-2">
                          <strong class="text-black">{{item?.quantity}}</strong>
                          @if (purchaseOrderObject.price_engineering_flag) {
                            <input
                              type="number" class="form-control order-qty-input"
                              [ngClass]="item.isSelected ? 'enabled' : 'disabled'"
                              [(ngModel)]="item.new_quantity" (change)="quantityChange(item)"
                              [ngModelOptions]="{standalone: true}" />
                          }
                        </div>
                      </td>
                      <td class="text-black po-table__unit-cost-cell" [ngStyle]="{'background-color': item?.color}">
                        {{item?.unit_price | currency:'USD'}}
                      </td>
                      <td class="po-table__contract-cost" [ngStyle]="{'background-color': item?.color}">
                      {{purchaseOrderObject.price_engineering_flag ? (item?.contract_price | currency: 'USD') : (item?.previous_quantity_total|currency :'USD')}}</td>
                      <!-- Stage 6.7 Phase 4: Estimated Vendor Tax (Read-only) -->
                      <td class="pt-4 text-black" [ngStyle]="{'background-color': item?.color}">
                        <span matTooltip="Estimated vendor tax from proposal" matTooltipPosition="above">
                          {{ (item.estimated_vendor_tax || 0) | currency: 'USD' }}
                        </span>
                      </td>
                      <!-- PE Previous Column -->
                      @if (purchaseOrderObject.price_engineering_flag) {
                        <td class="po-table__pe-previous-cell"
                          >
                          <span class="po-table__pe-previous-value">
                            {{item?.previous_quantity_total | currency:'USD'}}
                          </span>
                          @if (item?.previous_quantity_total > item.new_quantity_total) {
                            <i class="fa fa-arrow-up text-danger ms-1" aria-hidden="true"
                            ></i>
                          }
                          @if (item?.previous_quantity_total < item.new_quantity_total) {
                            <i class="fa fa-arrow-down text-success ms-1" aria-hidden="true"
                            ></i>
                          }
                        </td>
                      }
                      <!-- PE New Column -->
                      @if (purchaseOrderObject.price_engineering_flag) {
                        <td class="po-table__pe-new-cell"
                          [ngClass]="{'po-table__pe-new-cell--variance': item.new_quantity_total !== item.previous_quantity_total}">
                          <div class="po-table__pe-new-wrapper"
                            [ngClass]="{'enabled': item.isSelected, 'disabled': !item.isSelected}">
                            <input currencyMask
                              [options]="{ prefix: '', thousands: ',', decimal: '.', precision:'2', align:'left' }"
                              (keyup)="onChangeItemTotal($event, item)"
                              class="po-table__pe-new-input"
                              [(ngModel)]="item.new_quantity_total"
                              [ngModelOptions]="{standalone: true}"
                              placeholder="New Price" />
                            @if (item.new_quantity_total !== item.previous_quantity_total) {
                              <mat-icon class="po-pe-variance-icon"
                              >error_outline</mat-icon>
                            }
                          </div>
                          @if (item?.new_quantity_total > item.previous_quantity_total) {
                            <i class="fa fa-arrow-up text-danger ms-1" aria-hidden="true"
                            ></i>
                          }
                          @if (item?.new_quantity_total < item.previous_quantity_total) {
                            <i class="fa fa-arrow-down text-success ms-1" aria-hidden="true"
                            ></i>
                          }
                        </td>
                      }
                      <!-- Actions column -->
                      <td class="po-table__actions-td" [ngStyle]="{'background-color': item?.color}">
                        <button mat-icon-button class="po-table__delete-btn" matTooltip="Remove item"
                          (click)="selectedMaterial(false, item, i)">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
                <tfoot>
                  <tr class="bottom-table po-table__totals-row">
                    <td class="total" colspan="7">Total</td>
                    <td> </td>
                    <td>
                      <span class="po-table__total-badge" matTooltip="Total Contract Cost of All Items">{{ materialList?.length ? (calculation?.contract_price_total|currency:'USD') : '$0.00'}}</span>
                    </td>
                    <!-- Stage 6.7 Phase 4: Estimated Vendor Tax Total -->
                    <td>
                      <strong matTooltip="Total Estimated Vendor Tax" class="cursor-pointer">{{ getTotalEstimatedVendorTax() | currency:'USD' }}</strong>
                    </td>
                    @if (purchaseOrderObject.price_engineering_flag) {
                      <td class="po-table__pe-total-previous">
                        <span class="po-table__pe-total-badge--previous">
                          {{calculation?.previous_total | currency:'USD'}}
                        </span>
                      </td>
                    }
                    @if (purchaseOrderObject.price_engineering_flag) {
                      <td class="po-table__pe-total-new">
                        <span class="po-table__pe-total-badge--new">
                          {{calculation?.new_total | currency:'USD'}}
                        </span>
                      </td>
                    }
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <!-- G8: Empty state when no materials -->
            @if (!materialList?.length) {
              <div class="po-table__empty-state">
                <mat-icon>inventory_2</mat-icon>
                <p class="po-table__empty-title">No materials added</p>
                <p class="po-table__empty-subtitle">Select materials from the left panel to add them</p>
              </div>
            }
          </div>

          <!-- Vendor GROUP -->
          <div class="po-vendor-list__header">
            <div class="d-flex align-items-center gap-2">
              <span class="po-vendor-list__accent-bar"></span>
              <span class="title-under-line">Vendor PO List</span>
            </div>

            @if (vendorGroupList?.length) {
              <div class="d-flex justify-content-end">
                <div class="po-header__toggle">
                  <mat-slide-toggle [checked]="false" [ngModelOptions]="{standalone:true}"
                    (ngModelChange)="groupMaterialToggle()" [(ngModel)]="purchaseOrderObject.group_material_flag"
                  class="toggle_switch toggle_switch_new me-3">Group Material</mat-slide-toggle>
                </div>
              </div>
            }
          </div>
          <div class="create-vendor-container">
            <!-- For Vendor Group -->
            <app-vendor-group-panel
              [vendorGroupList]="vendorGroupList"
              [materialSplitGroupList]="materialSplitGroupList"
              [purchaseOrderObject]="purchaseOrderObject"
              [currencyMaskOptions]="currencyMaskOptions"
              [allSplitMaterialSelected]="allSplitMaterialSelected"
              [shippmentToggleFn]="shippmentToggle.bind(this)"
              [shippingChargesChangeFn]="shippingChargesChange.bind(this)"
              [vendorTaxChangeFn]="vendorTaxChange.bind(this)"
              [quoteAmountchangeFn]="quoteAmountchange.bind(this)"
              [removeVendorFn]="removeVendor.bind(this)"
              [allSplitMaterialSelectionFn]="allSplitMaterialSelection.bind(this)"
              [selectedSplitMaterialFn]="selectedSplitMaterial.bind(this)"
              [purchaseForm]="purchaseForm"
              [uniqueCodes]="getUniqueCodes()"
              (splitPO)="splitPO($event)"
            ></app-vendor-group-panel>

            <!-- For Separate PO -->
            @if (separatePOJobList?.length) {
              <app-vendor-group-panel
                [vendorGroupList]="separatePOJobList"
                [materialSplitGroupList]="materialSplitGroupList"
                [purchaseOrderObject]="purchaseOrderObject"
                [currencyMaskOptions]="currencyMaskOptions"
                [allSplitMaterialSelected]="allSplitMaterialSelected"
                [shippmentToggleFn]="shippmentToggle.bind(this)"
                [shippingChargesChangeFn]="shippingChargesChange.bind(this)"
                [vendorTaxChangeFn]="vendorTaxChange.bind(this)"
                [quoteAmountchangeFn]="quoteAmountchange.bind(this)"
                [removeVendorFn]="removeVendor.bind(this)"
                [allSplitMaterialSelectionFn]="allSplitMaterialSelection.bind(this)"
                [selectedSplitMaterialFn]="selectedSplitMaterial.bind(this)"
                [isSplitedItem]="true"
                [purchaseForm]="purchaseForm"
                (splitPO)="splitPO($event)"
                (undoSplit)="undoSplit($event)"
              ></app-vendor-group-panel>
            }

          </div>
        </form>
      </div>

      <!-- Right Panel -->
      <div class="po-right-panel">
        <!-- Job List -->
        @if (selectedJobList?.length  && purchaseOrderObject.type==='bulk') {
          <div class="po-right-panel__section">
            <div class="card m-b-30 card-wrapper-inner">
              <div class="po-summary__header">
                <mat-icon class="po-summary__header-icon">calculate</mat-icon>
                <span class="title-under-line">Job PO Summary </span>
              </div>
              <div class="mt-2 m-2">
                @for (item of selectedJobList; track item) {
                  <div>
                    <mat-expansion-panel #panel1>
                      <mat-expansion-panel-header [ngStyle]="{'background-color': item.color}">
                        <mat-panel-title class="ps-3">
                          {{item?.name}}
                        </mat-panel-title>
                        <mat-panel-description>
                          <mat-icon>{{ panel1.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div class="mt-4">
                        <app-purchase-order-summary [calculation]="item.calculation"
                        title="Job P.O Summary"></app-purchase-order-summary>
                      </div>
                    </mat-expansion-panel>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- Vendor PO Summary Header (GAP 2) -->
        <div class="po-summary__header">
          <mat-icon class="po-summary__header-icon">calculate</mat-icon>
          <span class="po-summary__header-title">Vendor PO Summary</span>
        </div>

        <!-- Vendor List (GAP 2/3/5) -->
        <div class="po-summary__vendors">
          @if (vendorGroupList?.length) {
            @for (item of vendorGroupList; track item) {
              <div>
                <mat-expansion-panel #panel1>
                  <!-- hideToggle: the template supplies its own chevron below.
                       Without this Material also renders `.mat-expansion-indicator`,
                       so two chevrons fought over the same corner. -->
                  <mat-expansion-panel-header hideToggle>
                    <mat-panel-title>
                      <span class="po-summary__vendor-name">{{item?.name}}</span>
                      <span class="po-vendor-badge">{{ item?.materialList?.length || 0 }} {{ (item?.materialList?.length || 0) === 1 ? 'item' : 'items' }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                      <span class="po-vendor-total">{{item?.calculation?.totalCost | currency:'USD'}}</span>
                      <mat-icon class="po-summary__chevron" [class.po-summary__chevron--expanded]="panel1.expanded">keyboard_arrow_down</mat-icon>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div class="po-vendor-detail">
                    <div class="po-vendor-detail__row">
                      <span class="po-vendor-detail__label">Material Cost</span>
                      <span class="po-vendor-detail__value">{{item?.calculation?.materialCost | currency:'USD'}}</span>
                    </div>
                    @if (item?.calculation?.costSaving > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--saving">
                        <span class="po-vendor-detail__label po-vendor-detail__label--green"><mat-icon class="po-vendor-detail__icon--down">trending_down</mat-icon> Cost Saving</span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--green">-{{item?.calculation?.costSaving | currency:'USD'}}</span>
                      </div>
                    }
                    @if (item?.calculation?.cost_escalation > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--escalation">
                        <span class="po-vendor-detail__label po-vendor-detail__label--red"><mat-icon class="po-vendor-detail__icon--up">trending_up</mat-icon> Cost Escalation</span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--red">+{{item?.calculation?.cost_escalation | currency:'USD'}}</span>
                      </div>
                    }
                    <div class="po-vendor-detail__row">
                      <span class="po-vendor-detail__label"><mat-icon class="po-vendor-detail__icon--truck">local_shipping</mat-icon> Shipping</span>
                      <span class="po-vendor-detail__value">{{item?.calculation?.shippingCharges | currency:'USD'}}</span>
                    </div>
                    <div class="po-vendor-detail__row po-vendor-detail__row--total">
                      <span class="po-vendor-detail__label">Total</span>
                      <span class="po-vendor-detail__value po-vendor-detail__value--bold">{{item?.calculation?.totalCost | currency:'USD'}}</span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
            }
          } @else {
            <div class="po-summary-empty">
              <mat-icon class="po-summary-empty__icon">inventory_2</mat-icon>
              <p class="po-summary-empty__text">Select materials to see summary</p>
            </div>
          }
          @if (separatePOJobList?.length) {
            @for (item of separatePOJobList; track item) {
              <div>
                <mat-expansion-panel #panel1>
                  <!-- hideToggle: the template supplies its own chevron below.
                       Without this Material also renders `.mat-expansion-indicator`,
                       so two chevrons fought over the same corner. -->
                  <mat-expansion-panel-header hideToggle>
                    <mat-panel-title>
                      <span class="po-summary__vendor-name">{{item?.name}}</span>
                      <span class="po-vendor-badge">{{ item?.materialList?.length || 0 }} {{ (item?.materialList?.length || 0) === 1 ? 'item' : 'items' }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                      <span class="po-vendor-total">{{item?.calculation?.totalCost | currency:'USD'}}</span>
                      <mat-icon class="po-summary__chevron" [class.po-summary__chevron--expanded]="panel1.expanded">keyboard_arrow_down</mat-icon>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div class="po-vendor-detail">
                    <div class="po-vendor-detail__row">
                      <span class="po-vendor-detail__label">Material Cost</span>
                      <span class="po-vendor-detail__value">{{item?.calculation?.materialCost | currency:'USD'}}</span>
                    </div>
                    @if (item?.calculation?.costSaving > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--saving">
                        <span class="po-vendor-detail__label po-vendor-detail__label--green"><mat-icon class="po-vendor-detail__icon--down">trending_down</mat-icon> Cost Saving</span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--green">-{{item?.calculation?.costSaving | currency:'USD'}}</span>
                      </div>
                    }
                    @if (item?.calculation?.cost_escalation > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--escalation">
                        <span class="po-vendor-detail__label po-vendor-detail__label--red"><mat-icon class="po-vendor-detail__icon--up">trending_up</mat-icon> Cost Escalation</span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--red">+{{item?.calculation?.cost_escalation | currency:'USD'}}</span>
                      </div>
                    }
                    <div class="po-vendor-detail__row">
                      <span class="po-vendor-detail__label"><mat-icon class="po-vendor-detail__icon--truck">local_shipping</mat-icon> Shipping</span>
                      <span class="po-vendor-detail__value">{{item?.calculation?.shippingCharges | currency:'USD'}}</span>
                    </div>
                    <div class="po-vendor-detail__row po-vendor-detail__row--total">
                      <span class="po-vendor-detail__label">Total</span>
                      <span class="po-vendor-detail__value po-vendor-detail__value--bold">{{item?.calculation?.totalCost | currency:'USD'}}</span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
            }
          }
        </div>

        <!-- Global Cost Breakdown (GAP 9) -->
        <!-- Split groups live in separatePOJobList and become POs too, so the panel must
             also show when every material has been split off the main vendor groups. -->
        @if (vendorGroupList?.length || separatePOJobList?.length) {
          <div class="po-right-panel__section po-breakdown__section">
            <div class="po-breakdown__label">COST BREAKDOWN</div>
            <div class="po-breakdown__grid">
              <div class="po-breakdown__card po-breakdown__card--material">
                <div class="po-breakdown__card-value">{{getGlobalMaterialCost() | currency:'USD'}}</div>
                <div class="po-breakdown__card-label">MATERIAL COST</div>
              </div>
              <div class="po-breakdown__card po-breakdown__card--saving">
                <div class="po-breakdown__card-value">{{getGlobalCostSaving() | currency:'USD'}}</div>
                <div class="po-breakdown__card-label">COST SAVING</div>
              </div>
              <div class="po-breakdown__card po-breakdown__card--shipping">
                <div class="po-breakdown__card-value">{{getGlobalShipping() | currency:'USD'}}</div>
                <div class="po-breakdown__card-label">SHIPPING</div>
              </div>
              <div class="po-breakdown__card po-breakdown__card--escalation">
                <div class="po-breakdown__card-value">{{getGlobalEscalation() | currency:'USD'}}</div>
                <div class="po-breakdown__card-label">ESCALATION</div>
              </div>
            </div>
            <!-- Orange Gradient Total Bar -->
            <div class="po-breakdown__total-bar">
              <div class="po-breakdown__total-section">
                <div class="po-breakdown__total-label">SUBTOTAL</div>
                <div class="po-breakdown__total-value">{{getGlobalSubtotal() | currency:'USD'}}</div>
              </div>
              <div class="po-breakdown__total-arrow">&rarr;</div>
              <div class="po-breakdown__total-section po-breakdown__total-section--right">
                <div class="po-breakdown__total-label">TOTAL COST</div>
                <div class="po-breakdown__total-value po-breakdown__total-value--grand">{{getGlobalTotal() | currency:'USD'}}</div>
              </div>
            </div>
          </div>
        }

      </div>
    </div>

